"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _RemovableTextInput = _interopRequireDefault(require("./RemovableTextInput"));

var _underscore = require("underscore");

var MultipleTextInput = _react.default.createClass({
  displayName: "MultipleTextInput",
  propTypes: {
    textInputs: _react.default.PropTypes.arrayOf(_react.default.PropTypes.string).isRequired,
    validateInput: _react.default.PropTypes.func,
    invalidInputText: _react.default.PropTypes.node,
    type: _react.default.PropTypes.string,
    isDisabled: _react.default.PropTypes.bool,
    onChange: _react.default.PropTypes.func.isRequired,
    addTextMessage: _react.default.PropTypes.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      textInputs: [''],
      type: 'text',
      isDisabled: false,
      invalidInputText: _react.default.createElement(_FormattedMessage.default, {
        message: 'settings.inputIsInvalid'
      }),
      addTextMessage: _react.default.createElement(_FormattedMessage.default, {
        message: 'settings.addAnotherInput'
      })
    };
  },
  langKey: function langKey(suffix) {
    return "settings." + suffix;
  },
  updateTextInputs: function updateTextInputs(textInputs, type, indexToRemove, value) {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        isDisabled = _this$props.isDisabled;
    if (isDisabled) return;

    switch (type) {
      case 'add':
        {
          var newTextInputs = Array.prototype.concat(textInputs, ['']);
          onChange(newTextInputs);
          break;
        }

      case 'update':
        {
          onChange((0, _underscore.map)(textInputs, function (input, index) {
            return indexToRemove === index ? value : input;
          }));
          break;
        }

      case 'remove':
        {
          var newList;

          if (textInputs.length === 1) {
            newList = [''];
          } else {
            newList = (0, _underscore.filter)(textInputs, function (input, index) {
              return indexToRemove !== index;
            });
          }

          onChange(newList);
          break;
        }

      default:
        {
          onChange(textInputs);
          break;
        }
    }
  },
  addTextInput: function addTextInput(textInputs) {
    this.updateTextInputs(textInputs, 'add');
  },
  removeTextInput: function removeTextInput(textInputs, index) {
    this.updateTextInputs(textInputs, 'remove', index);
  },
  updateTextInput: function updateTextInput(textInputs, index, value) {
    this.updateTextInputs(textInputs, 'update', index, value);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        isDisabled = _this$props2.isDisabled,
        addTextMessage = _this$props2.addTextMessage,
        type = _this$props2.type,
        validateInput = _this$props2.validateInput,
        invalidInputText = _this$props2.invalidInputText;
    var textInputs = this.props.textInputs.length > 0 ? this.props.textInputs : [''];
    return _react.default.createElement("div", {
      className: "settings-text-input-list"
    }, _react.default.createElement("div", null, (0, _underscore.map)(textInputs, function (input, index) {
      return _react.default.createElement(_RemovableTextInput.default, {
        key: index,
        text: input,
        type: type,
        className: "multiple-input-item",
        updateTextInput: function updateTextInput(value) {
          return _this.updateTextInput(textInputs, index, value);
        },
        removeTextInput: function removeTextInput() {
          return _this.removeTextInput(textInputs, index);
        },
        disabled: isDisabled,
        validateInput: validateInput,
        invalidInputText: invalidInputText
      });
    })), _react.default.createElement(_UIButton.default, {
      use: "link",
      onClick: function onClick() {
        return _this.addTextInput(textInputs);
      },
      disabled: isDisabled,
      className: "email-notifications__add-link"
    }, _react.default.createElement(_UIIcon.default, {
      name: "add"
    }), addTextMessage));
  }
});

var _default = MultipleTextInput;
exports.default = _default;
module.exports = exports.default;